import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status !== 401 || cfg._retry || (cfg.url || "").startsWith("/auth/")) return Promise.reject(err);
    cfg._retry = true;
    try {
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      await refreshing;
      return api(cfg);
    } catch {
      window.dispatchEvent(new Event("auth:logout"));
      return Promise.reject(err);
    }
  }
);

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
};

export const blankInputs = (counselorName = "", counselorMobile = "") => ({
  counselorMobile,
  enquiryDate: new Date().toLocaleDateString("en-CA"),
  childName: "",
  parentName: "",
  contact: "",
  email: "",
  grade: "",
  spot: true,
  revisit: false,
  sub: { normal: true, newSibling: false, group: false, referral: false, existingSibling: false },
  startMonth: "February",
  remarks: "",
  counselorName,
});
